import apiCall from '../../index'

const apiService = '/api-erpunigas/api/v1/helper/getQR'
const authorization = 'Authorization'
const tipoToken = 'Bearer'

const service = {
  getQR(params) {
    const query = `?seccion=${params.seccion}&idSeccion=${params.idSeccion}`
    return new Promise((resolve, reject) => {
      apiCall
        .defaults
        .headers
        .common[authorization] = `${tipoToken} ${localStorage.getItem('accessToken')}`
      apiCall
        .get(apiService + query)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
}

export default service
